import * as Mui from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { useForm, UseFormReturn } from "react-hook-form";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import FormInput from "../../common/FormInput";
import { domains2AutocompleteOptions, nameof } from "../../common/ObjectUtils";
import { ContextDamageForm } from "../DamageFormContext";
import { DamageFormTypes } from "../Types";
import { useHasScope } from "../../../../../config/globalConfig";
import { getAllEvent } from "../ManipulateValues";
import { useTranslation } from "react-i18next";

interface GeneralInfoCardProps {
    form?: UseFormReturn<any, any>;
}

const GeneralInfoCard = (props: GeneralInfoCardProps) => {
    const { generalInfo, eventTypes, task1 } = useContext(ContextDamageForm);

	const hasScope = useHasScope;

    const t = useOperationTranslation();
    const { i18n } = useTranslation()

    const [event, setEvent] = useState("");
    // const event = t(`masterDataDamage.event.${generalInfo?.event.code.replaceAll('.', '_').toLowerCase()}` as any, generalInfo?.event.descr) || "";

    const eventTypesOptions = useMemo(() => {
        return eventTypes?.map(et => ({
            value: et.id,
            label: t(`masterDataDamage.eventType.${et.code.replaceAll('.', '_').toLowerCase()}` as any, et.descr),
        })) || [];
    }, [eventTypes, i18n.language]);

    useEffect(() => {
        if (!generalInfo?.tenant) return;

        getAllEvent(generalInfo?.tenant)
            .then(res => {
                const allEvents = res.map(ev => ({
                    ...ev,
                    descr: t(`masterDataDamage.event.${ev.code.replaceAll('.', '_').toLowerCase()}` as any, ev.descr),
                }))

                const eventName = allEvents.find(ev => ev.id === generalInfo?.event.id)?.descr
                if (eventName) {
                    setEvent(eventName)
                }
            })
    }, [generalInfo])

    return(
        <Mui.Card>
            <Mui.CardContent>
                <Mui.Grid container spacing={3}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.IGeneralInfo>("id")}
                            type="text"
                            value={generalInfo?.progressive || ""}
                            fullWidth
                            label={t("damageForm.details.generalInfo.taskStatus.labels.formCode")}
                            disabled
                        />                                                    
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <Mui.Autocomplete 
                            value={generalInfo?.open === true ? "Open" : "Closed"}
                            options={[]}
                            fullWidth
                            disabled
                            renderInput={(args) => {
                                return(
                                    <Mui.TextField 
                                        {...args}
                                        label={t("damageForm.details.generalInfo.taskStatus.labels.status")}
                                    />
                                )
                            }}
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.IGeneralInfo>("createDate")}
                            value={generalInfo?.createDate}
                            type="date"
                            label={t("damageForm.details.generalInfo.taskStatus.labels.creationDate")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.IGeneralInfo>("insertionFlow")}
                            type="text"
                            value={generalInfo?.insertionFlow || ""}
                            fullWidth
                            label={t("damageForm.details.generalInfo.taskStatus.labels.insertionFlow")}
                            disabled
                        />                                                    
                    </Mui.Grid>


                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <Mui.Tooltip title={event}>
                            <Mui.Autocomplete
                                value={event}
                                options={[]}
                                fullWidth
                                disabled
                                renderInput={(args) => {
                                    return(
                                        <Mui.TextField 
                                            {...args}
                                            label={t("damageForm.details.generalInfo.taskStatus.labels.event")}
                                        />
                                    )
                                }}
                            />
                        </Mui.Tooltip>
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<DamageFormTypes.IGeneralInfoUpdate>("eventTypeId")}
                            type="select"
                            options={eventTypesOptions}
                            fullWidth
                            label={t("damageForm.details.generalInfo.taskStatus.labels.eventType")}
                            {...(props.form && !generalInfo?.migrated ? {
                                formInstance: props.form
                            } : {
                                value: generalInfo?.eventType.id,
                                disabled: true,
                            })}
							disabled={!hasScope("SCOPE_UPDATE_DAMAGE_DAMAGE_FORM_EVENT_TYPE")}

                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.IGeneralInfo>("eventTypeDate")}
                            value={generalInfo?.eventTypeDate}
                            type="date"
                            label={t("damageForm.details.generalInfo.taskStatus.labels.eventTypeUpdateDate")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <Mui.Autocomplete
                            value={generalInfo?.vehicleStatus || ""}
                            options={[]}
                            fullWidth
                            disabled
                            renderInput={(args)=> {
                                return(
                                    <Mui.TextField 
                                        {...args}
                                        label={t("damageForm.details.generalInfo.taskStatus.labels.vehicleStatus")}
                                    />
                                )
                            }}
                        />
                    </Mui.Grid> 
					
					<Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            name={nameof<DamageFormTypes.ITask1>("raSubstitution")}
                            value={task1?.raSubstitution}
                            type="checkbox"
                            label={t("damageForm.details.task1.vehicleStatus.labels.raSubstitution")}
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>

                </Mui.Grid>
            </Mui.CardContent>
        </Mui.Card>
    )
}
export default GeneralInfoCard;